var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('div',_vm._g({ref:"editable",staticClass:"input__input",attrs:{"contenteditable":""},on:{"keypress":_vm.onKeyPress}},_vm.listeners)),_c('label',{staticClass:"input__label"},[_vm._v("Participe do chat!")])])}
var staticRenderFns = []

export { render, staticRenderFns }